import React, { useCallback, useEffect, useRef, useState } from 'react';
import NoteTooltip from '../cells/meta/NoteTooltip';
import useWebSocketCaller from '../../../hooks/useWebSocketCaller';
import { useFolderListenerContext } from '../../../providers/FolderListenerContextProvider';
import { reformat } from '../../../hooks/useMyStrings';
import './WizardFolderEdit.css';

const WizardFolderEdit = ({parentFolderPath, parentFolder, folderName, switchToLabel, withError}) => {
  const taggedEditingRef = useRef(false);
  const {tagFolderEdit, clearFolderKInfo}  = useFolderListenerContext();
  const focusRef = useRef(null);
  const [content, setContent] = useState(null);
  const {sendMessage} = useWebSocketCaller();  
  const [errInfo, setErrInfo] = useState(null);
  
  //------[   Effect ]------
  //
  useEffect(()=>{
    if (withError) {
      const {newKey:newFolderName, message, suggestion, cause, logFinder} = withError;
      setContent(newFolderName);
      setErrInfo({
        subject: message,
        body: suggestion,
        cause: cause,
        logFinder: logFinder
      });      
    }
    else {
      setContent(folderName);
    }

    focusRef.current.focus();
  }, [parentFolder, folderName, withError]);

  //------ Effect Init Edit ------
  //
  useEffect(()=>{
    if (!taggedEditingRef.current) {
      tagFolderEdit(parentFolderPath, folderName)
        .then(()=>taggedEditingRef.current = true);
    }
  },[parentFolderPath, folderName, tagFolderEdit]);
  
  //------  Update Content  ------
  //
  const updateContent = useCallback((e)=>{
    const value = e.target.value;
    // TODO: Here, Validations, Auto-Fix, Replacements.. Also on the Server!
    const fixed = reformat(value);
    setContent(fixed);
  }, []);
  
  //------  Revert ------
  //
  const revert = useCallback(()=>{
    if (taggedEditingRef.current) {
      taggedEditingRef.current = false;
    }
    clearFolderKInfo(parentFolderPath, folderName)
      .then(()=>setContent(folderName))
      .then(()=>setErrInfo(null))
      .then(switchToLabel);
  }, [clearFolderKInfo, parentFolderPath, folderName, switchToLabel]);

  //------  Save  ------
  //
  const save = useCallback(()=>{
    if (content !== folderName) {
      sendMessage('rename-config-folder', {
        parentPath: parentFolderPath,
        oldFolderName:folderName,
        newFolderName:content
      });
    }
    else {
      revert();
    }
  }, [content, folderName, parentFolderPath, sendMessage, revert]);


  //------  On KeyDown  ------
  //
  const onKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      save();
    }
    else if (e.key === 'Escape') {
      revert();
    }
  }, [save, revert]);


  return (
    <div className='wizardFolderEdit'>
      {errInfo && <NoteTooltip subject={errInfo.subject} body={errInfo.body} cause={errInfo.cause} logFinder={errInfo.logFinder}/>}
      <input  className='wizardFolderInput'
              ref={focusRef}
              type='text'
              autoFocus={true}
              defaultValue={content}
              onChange={updateContent}
              onBlur={save}
              onKeyDown={onKeyDown}
              placeholder='Folder Name'
      />
    </div>
  );
};

export default WizardFolderEdit;